<template>
	<li class="navbar-item">
		<button title="Menu" @click='showMenu'>
			<i class="fa fa-bars"></i>
		</button>
	</li>
</template>

<script>
	export default{
		methods: {
			showMenu() {
				this.$store.dispatch('showMenu');
			}
		}
	}
</script>


// WEBPACK FOOTER //
// menu.vue?5eeff1e0